import { Book } from "types/book";
import { createStore } from "@methodjs/store";

export const initRecentBookList = (): Book[] => [];

const [useRecentBookList, setRecentBookList, getRecentBookList] =
  createStore(initRecentBookList);

export { useRecentBookList, setRecentBookList, getRecentBookList };
